import { NameValue } from '../';
import { WidgetConfiguration } from '../interfaces/WidgetInterfaces';

export class RequiredConfigs {

    public static SideNavNameValues(): NameValue[] {
        return [
            {name: 'Admin Side Navigation', value: 'Admin'}
        ];
    }

    public static Widgets(): WidgetConfiguration[] {
        return [
            {
                'name' : 'Admin Side Navigation',
                'supportMessage' : '', 'componentType' : 'GenericGroupedDataSideNav', 'description' : '',
                'dataConsumerConfiguration' : {
                    'dataPolicy' : 'None',
                    'fixedData' : {
                        'columns' : [ 'Category',       'Module' ],
                        'data' :    [   [ 'Actions',    'Landing Page'],
                                        [ 'Actions',    'Platform Config' ],
                                        [ 'Actions',    'Data Policy Testing' ],
                                        [ 'Actions',    'User Widget Preferences' ],
                                        [ 'Cache',      'Cached Data Report' ],
                                        [ 'Help',       'Developer Guidelines' ],
                                        [ 'Help',       'Diagnostics' ] ]
                    },
                },
                'contextMatchingRules' : [ ],
                'config' : {
                    'permanentContext' : [ { 'name' : 'Source', 'value' : 'Admin' } ],
                    'groupBy' : [ 'Category',  'Module' ],
                    'leafContext' : []
                }
            },
            {
                'name' : 'Platform Configuration',
                'supportMessage' : '', 'componentType' : 'MasterConfiguration', 'adminRequired' : true, 'description' : '',
                'dataConsumerConfiguration' : { 'dataPolicy' : 'None' },
                'contextMatchingRules' : [
                    { 'contextName' : 'source',     'valueMatch' : 'Admin',             'optional' : false },
                    { 'contextName' : 'Category',   'valueMatch' : 'Actions',           'optional' : false },
                    { 'contextName' : 'Module',     'valueMatch' : 'Platform Config',   'optional' : false }
                ]
            },

            {
                'name' : 'User Widget Preferences',
                'supportMessage' : '', 'componentType' : 'app-user-widget-prefs', 'adminRequired' : false, 'description' : '',
                'dataConsumerConfiguration' : { 'dataPolicy' : 'None' },
                'contextMatchingRules' : [
                    { 'contextName' : 'source',     'valueMatch' : 'Admin',                    'optional' : false },
                    { 'contextName' : 'Category',   'valueMatch' : 'Actions',                  'optional' : false },
                    { 'contextName' : 'Module',     'valueMatch' : 'User Widget Preferences',  'optional' : false }
                ]
            },
            {
                'name' : 'Landing Page',
                'supportMessage' : '', 'componentType' : 'app-landing-page', 'description' : '',
                'dataConsumerConfiguration' : { 'dataPolicy' : 'None' },
                'contextMatchingRules' : [
                    { 'contextName' : 'source',     'valueMatch' : 'Admin',             'optional' : false },
                    { 'contextName' : 'Category',   'valueMatch' : 'Actions',           'optional' : false },
                    { 'contextName' : 'module',     'valueMatch' : 'Landing Page',      'optional' : false }
                ]
            },
                    {
                'name' : 'Cached Data Report',
                'supportMessage' : '', 'componentType' : 'CacheDataAdmin', 'description' : '',
                'dataConsumerConfiguration' : { 'dataPolicy' : 'None' },
                'contextMatchingRules' : [
                    { 'contextName' : 'source',     'valueMatch' : 'Admin',              'optional' : false },
                    { 'contextName' : 'Category',   'valueMatch' : 'Cache',              'optional' : false },
                    { 'contextName' : 'module',     'valueMatch' : 'Cached Data Report', 'optional' : false }
                ]
            },
            {
                'name' : 'Widget Creation Help',
                'supportMessage' : '', 'componentType' : 'WidgetHelp', 'description' : '',
                'dataConsumerConfiguration' : { 'dataPolicy' : 'None' },
                'contextMatchingRules' : [
                    { 'contextName' : 'source',         'valueMatch' : 'Admin',                 'optional' : false },
                    { 'contextName' : 'Category',       'valueMatch' : 'Help',                  'optional' : false },
                    { 'contextName' : 'module',         'valueMatch' : 'Developer Guidelines',  'optional' : false }
                ]
            },
            {
                'name' : 'Diagnostics',
                'supportMessage' : '', 'componentType' : 'Diagnostics', 'description' : '',
                'dataConsumerConfiguration' : { 'dataPolicy' : 'None' },
                'contextMatchingRules' : [
                    { 'contextName' : 'source',         'valueMatch' : 'Admin',        'optional' : false },
                    { 'contextName' : 'Category',       'valueMatch' : 'Help',         'optional' : false },
                    { 'contextName' : 'module',         'valueMatch' : 'Diagnostics',  'optional' : false }
                ]
            },
            {
                'name' : 'Data Policy Testing',
                'supportMessage' : '', 'componentType' : 'app-data-policy-testing', 'description' : '',
                'dataConsumerConfiguration' : { 'dataPolicy' : 'None' },
                'contextMatchingRules' : [
                    { 'contextName' : 'source',         'valueMatch' : 'Admin',                 'optional' : false },
                    { 'contextName' : 'Category',       'valueMatch' : 'Actions',               'optional' : false },
                    { 'contextName' : 'module',         'valueMatch' : 'Data Policy Testing',   'optional' : false }
                ]
            }
        ];
    }
}
